








import { Component, Vue } from "vue-property-decorator";
import FormularioOIRS from "@/components/Formularios/FormularioOIRS.vue";

@Component({
  components: {
    FormularioOIRS
  },
  meta: {
    // sets document title
    title: "Formulario OIRS - Ilustre Municipalidad de Punta Arenas",
    // optional; sets final title as "Index Page - My Website", useful for multiple level meta
    //titleTemplate: title => `${title} - My Website`,

    // meta tags
    meta: {
      description: {
        name: "description",
        content: "Ilustre Municipalidad de Punta Arenas"
      },
      keywords: { name: "keywords", content: "Punta Arenas" },
      equiv: {
        "http-equiv": "Content-Type",
        content: "text/html; charset=UTF-8"
      }
    }
  }
})
export default class OirsView extends Vue {
  private mounted() {
    document.title = "Formulario OIRS - Ilustre Municipalidad de Punta Arenas";
  }
}
